import {
    ACCESSORIES_PROCESS_DC_INWARD_DETAILS_PO_DETAILS_DISABLED,
    ACCESSORIES_PROCESS_DC_INWARD_DETAILS_USERFORM_RESET,
    CREATE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_FAILURE,
    CREATE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_FORM,
    CREATE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_REQUEST,
    CREATE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_SUCCESS,
    DELETE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_FAILURE,
    DELETE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_REQUEST,
    DELETE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_SUCCESS,
    FETCH_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_FAILURE,
    FETCH_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_REQUEST,
    FETCH_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_SO_AND_SN_FAILURE,
    FETCH_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_SO_AND_SN_REQUEST,
    FETCH_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_SO_AND_SN_SUCCESS,
    FETCH_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_SUCCESS,
    FETCH_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_WITHOUT_ID_SUCCESS,
    FETCH_ACCESSORIES_PROCESS_DC_PREVIOUS_LIST_FAILURE,
    FETCH_ACCESSORIES_PROCESS_DC_PREVIOUS_LIST_REQUEST,
    FETCH_PREVIOUS_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_FAILURE,
    FETCH_PREVIOUS_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_REQUEST,
    FETCH_PREVIOUS_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_SUCCESS,
    FETCH_SINGLE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_FAILURE,
    FETCH_SINGLE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_REQUEST,
    FETCH_SINGLE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_SUCCESS,
    RESET_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_INFO,
    UPDATE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_FAILURE,
    UPDATE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_FORM,
    UPDATE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_REQUEST,
    UPDATE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_SUCCESS
} from "./accessoriesProcessDCInwardDetails.actionsType";


export const ACCESSORIES_PROCESS_DC_INWARD_DETAILS = 'accessoriesProcessDCInwardDetails';

let initialState = {
    loading: false,
    accessoriesProcessDCInwardDetails: [],
    accessoriesProcessDCInwardDetailsWithoutId: [],

    accessoriesProcessDCInwardDetailsForm: {
        fldRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0,
        fldDiscountPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0
    },
    previousGetList: [],
    SOAndSNGetList: [],
    selectedState: {},
    errorMessage: '',
    isProcessDCDetailsDisabled: false
};

export let accessoriesProcessDCInwardDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_REQUEST:
        case CREATE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_REQUEST:
        case UPDATE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_REQUEST:
        case FETCH_SINGLE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_REQUEST:
        case DELETE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_REQUEST:
        case FETCH_ACCESSORIES_PROCESS_DC_PREVIOUS_LIST_REQUEST:
        case FETCH_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_SO_AND_SN_REQUEST:
        case FETCH_PREVIOUS_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesProcessDCInwardDetails: updatePayload
            };
        case FETCH_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_WITHOUT_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesProcessDCInwardDetailsWithoutId: updatePayload
            };
        case CREATE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,

                accessoriesProcessDCInwardDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0
                },
                isProcessDCDetailsDisabled: false
            };
        case UPDATE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedState: {},
                accessoriesProcessDCInwardDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldIGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0
                },
                isProcessDCDetailsDisabled: false
            };
        case FETCH_SINGLE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedState: updatePayload,
                accessoriesProcessDCInwardDetailsForm: { ...updatePayload }
            };
            {
                /*case FETCH_PREVIOUS_ACCESSORIES_PO_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                previousGetList: updatePayload
            };*/
            }
        case DELETE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesProcessDCInwardDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0
                },
                selectedState: {},
                isProcessDCDetailsDisabled: false
            };
        case RESET_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_INFO:
            return {
                ...state,
                accessoriesProcessDCInwardDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldDiscountPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0
                }
            };
        case CREATE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_FORM:
        case UPDATE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_FORM:
            return {
                ...state,
                loading: false,
                accessoriesProcessDCInwardDetailsForm: {
                    ...state.accessoriesProcessDCInwardDetailsForm,
                    [payload.key]: payload.value
                }
            };

        case FETCH_PREVIOUS_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                previousGetList: updatePayload
            };
        case FETCH_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_SO_AND_SN_SUCCESS:
            return {
                ...state,
                loading: false,
                SOAndSNGetList: updatePayload
            };
        case FETCH_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_FAILURE:
        case CREATE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_FAILURE:
        case UPDATE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_FAILURE:
        case FETCH_SINGLE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_FAILURE:
        case DELETE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_FAILURE:
        case FETCH_ACCESSORIES_PROCESS_DC_PREVIOUS_LIST_FAILURE:
        case FETCH_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_SO_AND_SN_FAILURE:
        case FETCH_PREVIOUS_ACCESSORIES_PROCESS_DC_INWARD_DETAILS_FAILURE:
            return {
                ...state,
                loading: false
            };
        case ACCESSORIES_PROCESS_DC_INWARD_DETAILS_USERFORM_RESET:
            return {
                ...state,
                accessoriesProcessDCInwardDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldDiscountPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0
                },
                selectedState: {},
                isProcessDCDetailsDisabled: false
            };
        case ACCESSORIES_PROCESS_DC_INWARD_DETAILS_PO_DETAILS_DISABLED:
            return {
                ...state,
                isProcessDCDetailsDisabled: payload
            };
        default:
            return state;
    }
};
